import { useLocation, useNavigate } from 'react-router-dom';
import { Input } from 'antd';
import { useEffect, useState } from 'react';

import useTranslation from 'customHooks/translate';
import { useQuery } from '@tanstack/react-query';
import { ACCOUNT_INFO } from 'events/types';
import { getAccountData } from 'services/accounts';

interface IProps {
  transactionType: string;
  handleOpen: () => void;
  setPartnerName: (partnerName: string) => void;
  partnerName: string;
  open: boolean;
}

const DashboardHeader = ({
  handleOpen,
  transactionType,
  setPartnerName,
  partnerName,
  open,
}: IProps) => {
  const [activeTab, setActiveTab] = useState<string>('debitors');

  const accountInfoQuery = useQuery({
    queryKey: [ACCOUNT_INFO],
    queryFn: getAccountData,
    select: (response) => response.data.data,
  });

  useEffect(() => {
    if (!isDebitor && !isCreditor) {
      navigate('debitors', { replace: true });
    }
  }, []);

  const translation = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location?.pathname?.includes('debitors')) {
      setActiveTab('debitors');
    } else if (location?.pathname?.includes('creditors')) {
      setActiveTab('creditors');
    } else setActiveTab('debitors');
  });

  const isDebitor = activeTab === 'debitors';
  const isCreditor = activeTab === 'creditors';
  const showStatistics = !accountInfoQuery?.data?.isSubUser;

  const handleClickTab = (path: string) => {
    setActiveTab(path);
    navigate(`${path}`);
    setPartnerName('');
  };

  return (
    <div className="mb-[12px] flex flex-wrap items-center justify-between gap-[10px] px-[16px] pt-[16px]">
      <div className="grid w-full grid-cols-[repeat(auto-fit,minmax(100px,1fr))] items-center rounded-[8px] bg-gray-100 p-[2px] md:flex md:w-fit">
        <button
          onClick={() => handleClickTab('debitors')}
          className={`rounded-[6px] px-[20px] py-[8px] text-[14px] transition-all
        ${isDebitor ? 'bg-green-600 text-white' : 'text-[#1D1D1D]'}`}
        >
          {translation.dashboard.SideReport_CBItemsDr}
        </button>

        <button
          onClick={() => handleClickTab('creditors')}
          className={`rounded-[6px] px-[20px] py-[8px] text-[14px]  transition-all
        ${isCreditor ? 'bg-green-600 text-white' : 'text-black'}`}
        >
          {translation.dashboard.SideReport_CBItemsCr}
        </button>
      </div>
      <Input
        onChange={(event) => setPartnerName(event?.target?.value)}
        value={partnerName}
        className="max-h-10 w-full rounded-[8px] border-none bg-[#F6F6F6] text-[#1D1D1D] transition-all duration-300 ease-in-out hover:bg-gray-100 sm:w-[280px]"
        placeholder={
          transactionType === translation.dashboard.PartnerTabDr
            ? translation.dashboard.PartnerSearchDr
            : translation.dashboard.PartnerSearchCr
        }
      />
      {showStatistics && (
        <button
          onClick={handleOpen}
          className="flex w-full items-center rounded-[6px] bg-[#F6F6F6] px-[24px] py-[12px] text-[14px] font-normal leading-[16px] text-[#444444] transition-all duration-300 ease-in-out hover:bg-gray-100 sm:w-max md:text-[14px]"
        >
          <img
            className="mr-[5px] h-5 w-5"
            src="./assets/arrow-up.svg"
            alt=""
          />
          {open
            ? translation.dashboard.Statistics_Hide
            : translation.dashboard.Statistics_Show}
        </button>
      )}
    </div>
  );
};

export default DashboardHeader;
